import React, {useState, useEffect} from 'react';
import Heading from '@tds/core-heading'
import Box from '@tds/core-box'
import axios from 'axios';
import FileDownload from 'js-file-download';
import {config, apiHost} from '../utils/request';
import {useTranslationsContext} from '../context/TranslationsContext';
import {stylePage, styleInputField, styleTextBold, ErrorStyles} from './styles';
import ValidateLoader from '../UI/validateLoader';

const Reporting = ({history}) => {
    const {
        WLS: {
            REPORTING: {
                Reporting,
                RequiredField,
                StartDate,
                EndDate,
                Total,
                FilterResults,
                ExportCSV
            }
        }
    } = useTranslationsContext();

    const [loading, setLoading] = useState(false);
    const [showExportButton, setShowExportButton] = useState(false);
    const [ordersList, setOrdersList] = useState();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [error, setError] = useState('');
    const [totalOrders, setTotalOrders] = useState(0);;
    const userProfile = JSON.parse(localStorage.getItem('userProfile'));
    const {
        role: {name = ''} = {}
    } = userProfile || {};


    if (name !== 'ADMIN') {
        history.push('/');
    }


    const validateInput = () => {
        if (startDate.length > 0 && endDate.length > 0) {
            return true
        } else {
            if (startDate.length <= 0) {
                setStartDateError(RequiredField)
            }
            if (endDate.length <= 0) {
                setEndDateError(RequiredField)
            }
            return false
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const postData = () => {
        if (validateInput()) {
            setStartDateError('');
            setEndDateError('');
            setLoading(true);
            // API to fetch all the orders
            axios.post(`${apiHost}/orders/export/wls-report?typeOfOrder=WLS`, {startDate, endDate}, config())
                .then((response) => response.data)
                .then((fileData) => {
                    setOrdersList(fileData)
                    // API to fetch count of all the orders
                    axios.post(`${apiHost}/orders/getReportCount?typeOfOrder=WLS`, {startDate, endDate}, config())
                        .then((resposne) => setTotalOrders(resposne.data.total))
                        .catch((error) => setError(error))
                })
                .catch((error) => setError(error))
                .finally(() => {
                    setLoading(false)
                    setShowExportButton(true)
                })
        }
    }

    const exportFile = () => {
        FileDownload(ordersList, 'WLS_Orders.csv')
    }

    return (
        <>
            <div style={stylePage}>
                <div className="container 85%">
                    <div id="main">
                        <div id="main-wrapper">
                            <div id="main-content">
                                {loading && <ValidateLoader message="LOADING"/>}
                                <Heading level="h1">{Reporting}</Heading>
                                <Box tag="fieldset" between={2} style={styleInputField}>
                                    <label style={styleTextBold}>{StartDate}</label>
                                </Box>
                                <input
                                    type="date"
                                    className="frg-input-field color-light"
                                    style={{width: '100%'}}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <div style={ErrorStyles}>{startDateError}</div>
                                <Box tag="fieldset" between={2} style={styleInputField}>
                                    <label style={styleTextBold}>{EndDate}</label>
                                </Box>
                                <input
                                    type="date"
                                    className="frg-input-field color-light"
                                    style={{width: '100%'}}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                                <div style={ErrorStyles}>{endDateError}</div>
                                {error.length > 0 ? <p>{error}</p> : ''}
                                <br/><br/>
                                <p>{Total}: {totalOrders}</p>
                                <br/><br/>
                                <button className="frg-button color-green" style={{marginRight: 5}} variant="primary"
                                        type='submit' onClick={() => postData()}>
                                    {FilterResults}
                                </button>
                                <button className="frg-button color-purple" variant="primary" type='submit'
                                        disabled={!showExportButton} onClick={() => exportFile()}>
                                    {ExportCSV}
                                </button>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Reporting;